import { useState, useEffect } from 'react'
import { supabase } from '../lib/supabase'

/**
 * Hook to fetch API configuration for a customer
 * Returns max_time_range_hours and other API limits
 */
export function useApiConfig(customerId) {
	const [config, setConfig] = useState({
		max_time_range_hours: 168, // Default fallback
		max_requests_per_hour: 50,
		loading: true,
		error: null
	})

	useEffect(() => {
		if (!customerId) {
			setConfig(prev => ({ ...prev, loading: false }))
			return
		}

		const fetchConfig = async () => {
			try {
				const { data, error } = await supabase
					.from('api_config')
					.select('max_time_range_hours, max_requests_per_hour')
					.eq('customer_id', customerId)
					.is('api_key_id', null) // Get customer-level config
					.maybeSingle()

				if (error) throw error

				if (data) {
					setConfig({
						max_time_range_hours: data.max_time_range_hours,
						max_requests_per_hour: data.max_requests_per_hour,
						loading: false,
						error: null
					})
				} else {
					// No config found, use defaults
					setConfig({
						max_time_range_hours: 12,
						max_requests_per_hour: 50,
						loading: false,
						error: null
					})
				}
			} catch (err) {
				console.error('Error fetching API config:', err)
				setConfig({
					max_time_range_hours: 12, // Fallback
					max_requests_per_hour: 50,
					loading: false,
					error: err.message
				})
			}
		}

		fetchConfig()
	}, [customerId])

	return config
}
